import { jsx } from "react/jsx-runtime";
import { BoxSelection, Checkbox } from "@wix/wix-ui-tpa/cssVars";
import classNames from "classnames";
import React__default from "react";
import { useFocusFieldEvent } from "../../contexts/events-context.js";
import { classes } from "./box-selection-item-wut.st.css";
const BoxSelectionItem = (props) => {
  const optionRef = React__default.createRef();
  const { content, className, hasError, inputId, ...optionProps } = props;
  const optionClassName = classNames(className, classes.option, classes.theme, {
    [classes.hover]: props.forcedHover,
    [classes.error]: hasError
  });
  useFocusFieldEvent(() => {
    optionRef.current?.focus({ preventScroll: true });
  }, inputId);
  return /* @__PURE__ */ jsx(
    BoxSelection.Option,
    {
      ...optionProps,
      ref: optionRef,
      className: optionClassName,
      children: content
    }
  );
};
BoxSelectionItem.includeCheckboxInBundle = Checkbox;
export {
  BoxSelectionItem
};
//# sourceMappingURL=box-selection-item.js.map
